import { call, put } from 'redux-saga/effects'

import { fetchInvoicesReadyToPay } from 'services/invoices'

import { onOpenNotification } from 'redux/notification/reducer'

import {
	getInvoicesReadyToPayFailure,
	getInvoicesReadyToPaySuccess,
} from '../reducer'
import { IInvoicesReadyToPay } from '../types'

export function* getInvoicesReadyToPaySaga() {
	try {
		const response: IInvoicesReadyToPay = yield call(fetchInvoicesReadyToPay)

		yield put(
			getInvoicesReadyToPaySuccess(response)
		)
	} catch (e) {
		const error = e as { message: string }

		yield put(getInvoicesReadyToPayFailure())

		yield put(
			onOpenNotification({
				message: error.message,
				notificationType: 'error',
			})
		)
	}
}
